module.exports = __webpack_public_path__ + "static/media/Accueuil et jeunesse sans ombre.7232f29b.svg";